import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getRandomColor} from "../utils/GetRandomColor";

export default function SocialLink({ icon, text, linkText, href }) {
    const textStyles = {
        color: '#ffffff',
        gap: '6px',
        display: 'inline-flex',
        alignItems: 'center',
        marginTop: "5px",
    }
    const linkTextStyles = {
        color: '#ffffff',
        backgroundColor: getRandomColor(),
        textDecoration: 'none',
        padding: '2px',
        fontWeight: 'bolder',
    };
    
    return(
        <p style={textStyles}>
            {icon && <FontAwesomeIcon icon={icon} />}
            {text}:
            <a href={href} style={linkTextStyles} target={"_blank"} rel="noopener noreferrer">{linkText}</a>
        </p>
    );
}
    